import React, { Fragment, useState, useEffect } from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';

import { SHARED_PASSAGE_JSON } from 'legacy/src/components/learnosity/utils/constants';
import { setWidgetFields } from 'legacy/src/components/learnosity/utils/helpers';

import LearnosityQuestionEditor from './LearnosityQuestionEditor';
import LearnositySharedPassageTemplate from './LearnositySharedPassageTemplate';
import Button from 'chameleon/ui-stack/ui/base/button';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';

import './LearnositySharedPassage.scss';

const LearnositySharedPassage = ({
  isEdit,
  isVisibleByDefault,
  isLoading,
  isDeletable,
  onAddPassage = () => {},
  initOptions,
}) => {
  const [instance, setInstance] = useState(null);
  const [isVisible, setIsVisible] = useState(isVisibleByDefault);
  const [hasWidget, setHasWidget] = useState(isVisibleByDefault);

  const addPassage = () => {
    setIsVisible(true);
    !hasWidget && instance.setWidget(SHARED_PASSAGE_JSON);
    setHasWidget(true);
    onAddPassage(instance);
  };

  const removePassage = () => {
    setWidgetFields(instance.editorApp(), { heading: '', content: '' });
    onAddPassage(null);
    setIsVisible(false);
  };

  const hasDeleteButton = isEdit && isVisible && instance && isDeletable;
  const isAddVisible = isEdit && !isVisible && (instance || isVisibleByDefault);

  useEffect(
    () => () => {
      setInstance(null);
    },
    [],
  );

  useEffect(() => {
    setIsVisible(isVisibleByDefault);
  }, [isVisibleByDefault]);

  return (
    <Fragment>
      <LearnositySharedPassageTemplate />

      {isAddVisible && (
        <ButtonWithIcon
          isLink
          isNaked
          icon="addCircleOutline"
          className="text-base"
          iconClassName="text-blue-500"
          onClick={addPassage}
        >
          Add a Passage or Stimulus
        </ButtonWithIcon>
      )}

      {hasDeleteButton && (
        <div className="lrn-passage-toolbar">
          <Button isLink isNaked onClick={removePassage}>
            <Icon name="xmark" />
          </Button>
        </div>
      )}

      <div hidden={!isVisible} aria-hidden={!isVisible}>
        <LearnosityQuestionEditor
          hasNoToolbar
          isLoading={isLoading}
          isEdit={isEdit}
          shouldSetWidgets={false}
          initOptions={initOptions}
          onReady={(app) => {
            onAddPassage(app);
            setInstance(app);
          }}
        />
      </div>
    </Fragment>
  );
};

export default LearnositySharedPassage;
